import { useGameStore } from '@/store/gameStore'
import { useSessionStore } from '@/store/sessionStore'
import { useAudioContext } from '@/contexts/AudioContext'
import { iconMusic, iconSound, iconInfo, iconMenu } from '@/assets/ui/icons'
import { currencyDisplayFromCode, fromMinor } from '@/utils/money'

interface BottomPanelProps {
  onHistoryOpen?: () => void
  onInfoOpen?: () => void
  isInfoOpen?: boolean
  isHistoryOpen?: boolean
}

// Стиль шрифта по ТЗ
const fontStyle: React.CSSProperties = {
  fontFamily: "'Big Shoulders Display', sans-serif",
  fontWeight: 700,
  fontSize: '23px',
  lineHeight: '100%',
}

// Фильтр для цвета #F8DDCA (бежевый)
const iconFilterBeige = 'brightness(0) invert(97%) sepia(8%) saturate(997%) hue-rotate(321deg) brightness(101%) contrast(96%)'
// Фильтр для красного (#DC3F48) — когда info активна
const iconFilterRed = 'brightness(0) invert(38%) sepia(93%) saturate(1065%) hue-rotate(330deg) brightness(92%) contrast(93%)'

export default function BottomPanel({ onHistoryOpen, onInfoOpen, isInfoOpen, isHistoryOpen }: BottomPanelProps) {
  const { balance } = useGameStore()
  const { currencyCode } = useSessionStore()
  const { isMusicEnabled, toggleMusic, isSoundEnabled, toggleSound, playSfx } = useAudioContext()

  const handleMusicToggle = () => {
    playSfx('click')
    toggleMusic()
  }

  const handleSoundToggle = () => {
    // Проигрываем звук ДО отключения, чтобы пользователь услышал feedback
    if (isSoundEnabled) {
      playSfx('click')
    }
    toggleSound()
  }

  return (
    <div className="w-full h-[60px] bg-[#243043] flex items-center justify-between px-5">
      {/* Левая часть: Музыка и Звук */}
      <div className="flex items-center gap-4">
        <button
          onClick={handleMusicToggle}
          className={`w-8 h-8 flex items-center justify-center ${isMusicEnabled ? 'opacity-100' : 'opacity-40'}`}
        >
          <img src={iconMusic} alt="Music" className="w-6 h-6" style={{ filter: iconFilterBeige }} />
        </button>

        <button
          onClick={handleSoundToggle}
          className={`w-8 h-8 flex items-center justify-center ${isSoundEnabled ? 'opacity-100' : 'opacity-40'}`}
        >
          <img src={iconSound} alt="Sound" className="w-6 h-6" style={{ filter: iconFilterBeige }} />
        </button>
      </div>

      {/* Центр: Баланс */}
      <span style={{ ...fontStyle, color: '#F8DDCA' }}>
        Balance: {fromMinor(balance)}{currencyCode ? currencyDisplayFromCode(currencyCode) : ''}
      </span>

      {/* Правая часть: Инфо и Меню */}
      <div className="flex items-center gap-4">
        <button
          onClick={onInfoOpen}
          className="w-8 h-8 flex items-center justify-center"
        >
          <img
            src={iconInfo}
            alt="Info"
            className="w-6 h-6"
            style={{ filter: isInfoOpen ? iconFilterRed : iconFilterBeige }}
          />
        </button>

        <button
          onClick={onHistoryOpen}
          className="w-8 h-8 flex items-center justify-center"
        >
          <img src={iconMenu} alt="Menu" className="w-6 h-6" style={{ filter: isHistoryOpen ? iconFilterRed : iconFilterBeige }} />
        </button>
      </div>
    </div>
  )
}



